// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1QFDg","name":"ConsentHeader_name__16POz","birthday":"ConsentHeader_birthday__vCCOL","skeleton":"ConsentHeader_skeleton__3NV7l"};